import { render, staticRenderFns } from "./HotSpot.vue?vue&type=template&id=b8be6ba6&scoped=true&"
import script from "./HotSpot.vue?vue&type=script&lang=js&"
export * from "./HotSpot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8be6ba6",
  null
  
)

export default component.exports